import AICapabilities from "@/components/sections/AICapabilities";
import ROICalculator from "@/components/sections/ROICalculator";
import { Link } from "react-router-dom";
import AICrystal from "@/components/three/AICrystal";

export default function AIPage() {
  return (
    <>
      <section className="relative pt-12 pb-12 overflow-hidden">
        <div className="absolute inset-0 dot-grid opacity-20 pointer-events-none" />
        <div className="absolute -top-20 right-0 w-[500px] h-[500px] bg-[#F97316] mix-blend-screen blur-[180px] opacity-20 pointer-events-none" />
        <div className="container-x relative grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] gap-10 items-center">
          <div className="reveal">
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">LocateOS AI</div>
            <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
              The AI co-pilot for your locate operation.
            </h1>
            <p className="mt-5 text-lg text-[#94A3B8] leading-relaxed">
              LocateOS AI reads every ticket, every closeout, and every shift — and gives your supervisors and executives an operator-grade view of what's at risk right now.
            </p>
            <div className="mt-7 flex gap-3">
              <Link to="/demo" className="bg-[#F97316] hover:bg-[#ea580c] text-white font-semibold px-6 py-3 rounded-lg shadow-[0_8px_24px_rgba(249,115,22,0.4)]">
                Get a Live AI Walkthrough
              </Link>
            </div>
          </div>
          <div className="reveal h-[360px] md:h-[420px]">
            <AICrystal className="h-full w-full" />
          </div>
        </div>
      </section>

      <AICapabilities />
      <ROICalculator />
    </>
  );
}
